import { useState, useEffect, useCallback } from 'react';
import { container } from '@/di';
import { TYPES } from '@/di/tokens';
import { ListTenantsAction } from '@/application/actions';
import type { TenantGridDTO } from '@/domain/repositories/ITenantRepository';

export const useTenants = () => {
  const [tenants, setTenants] = useState<TenantGridDTO[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const loadTenants = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const action = container.get<ListTenantsAction>(TYPES.ListTenantsAction);
      const result = await action.execute();
      setTenants(result);
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to load tenants');
      setError(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadTenants();
  }, [loadTenants]);

  return { tenants, isLoading, error, refetch: loadTenants };
};
